<template>
  <div class="vap-lyt-1-container">
    <div class="vap-lyt-1-side-rail" :class="{ debug: debugLayout }" />
    <div class="vap-lyt-1-main-content">
      <TopBar class="vap-lyt-1-top-bar" :class="{ debug: debugLayout }" />
      <div class="vap-lyt-1-content-area">
        <TheMainSideNav
          v-if="!isFullPage"
          class="vap-lyt-1-main-side-nav"
          :class="{
            debug: debugLayout,
            show: showMainSideNav,
            'mobile-view': mainSideNavOnMobileActive,
          }"
          @itemSelected="itemSelectedFromSideBar"
        />
        <router-view
          :key="$route.fullPath"
          to="/"
          class="vap-lyt-1-main"
          :class="{ debug: debugLayout }"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TheMainSideNav from "@/components/mainViews/TheMainSideNav.vue";
import TopBar from "@/components/mainViews/TopBar.vue";

export default {
  name: "TheMainViewWithSharedSideRail",
  components: {
    TheMainSideNav,
    TopBar,
  },
  data: function () {
    return {
      debugLayout: false,
      beforeMdBreakpoint: false,
      mainSideNavOnMobileActive: false,
      inMdBreakpoint: false,
    };
  },
  computed: {
    automateBridgeEnabled() {
      return this.$store.state.systemSettings.featureFlags.vasionAutomateBridge;
    },
    isFullPage() {
      return (
        this.$route.name === "TheNewFormView" ||
        this.$route.name === "NewDocument" ||
        this.$route.name === "SignatureEditDocument" ||
        this.$route.name === "ConfigureEmailTemplate" ||
        this.$route.name === "EditDocumentTemplate" ||
        this.$route.name === "TheVasionHome" ||
        this.$route.name == 'SearchResults'
      );
    },
    showMainSideNav() {
      return !this.beforeMdBreakpoint || this.mainSideNavOnMobileActive || this.inMdBreakpoint;
    },
  },
  mounted() {
    this.handleWindowResize();
    window.addEventListener("resize", this.handleWindowResize);
    document.addEventListener("ProRailNavigation", this.handleProRailNavigation);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleWindowResize);
    document.removeEventListener("ProRailNavigation", this.handleProRailNavigation);
  },
  methods: {
    handleProRailNavigation() {
      const width = window.innerWidth;
      const icon = document.querySelector("#open-siderail-btn > span.v-btn__content > i");
      const sideRailBtn = document.querySelector("#open-siderail-btn");

      if (width < 600 && icon.textContent === "close") {
        sideRailBtn.click();
        this.mainSideNavOnMobileActive = true;
      }

      if (width >= 600 && width < 960) {
        this.inMdBreakpoint = true;
      }
    },
    handleWindowResize() {
      const width = window.innerWidth;

      if (width < 960) {
        this.beforeMdBreakpoint = true;
      } else {
        this.beforeMdBreakpoint = false;
      }

      if (width >= 600 && width < 960) {
        this.inMdBreakpoint = true;
      } else {
        this.inMdBreakpoint = false;
      }
    },
    itemSelectedFromSideBar() {
      this.mainSideNavOnMobileActive = false;
      this.inMdBreakpoint = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/light-theme-system-palette.scss";
@import "@/assets/css/vuetify3Breakpoints.scss";
// ------------------------------------------------------------ Start of LAYOUT
.vap-lyt-1-container {
  display: flex;
  height: 100vh;
  width: 100vw;
  gap: unset;
  background-color: $surface;
  overflow-y: hidden;
}
.vap-lyt-1-side-rail {
  width: unset;

  @include breakpoint(sm) {
    width: 72px;
  }
}
.vap-lyt-1-main-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: unset;
  padding: unset;
  width: calc(100vw - 72px);
  height: 100vh;

  @include breakpoint(sm) {
    gap: 12px;
    padding: 24px;
  }
}
.vap-lyt-1-top-bar {
  height: 64px;

  @include breakpoint(sm) {
    height: 48px;
  }
}
.vap-lyt-1-content-area {
  flex: 1;
  display: flex;
  gap: 10px;
  overflow: auto;
  max-height: calc(100vh - 64px);

  @include breakpoint(sm) {
    overflow: unset;
    max-height: calc(100vh - 108px);
  }
}
.vap-lyt-1-main-side-nav {
  width: 230px;
  display: none;
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.vap-lyt-1-main-side-nav.mobile-view {
  position: absolute;
  background: $primary;
  width: 100%;
  padding: 22px !important;
  height: calc(100vh - 64px);
  text-align: center;
  z-index: 10;
}
::v-deep .vap-lyt-1-main-side-nav.mobile-view * {
  color: $on-primary;
  fill: $on-primary;
}
::v-deep .vap-lyt-1-main-side-nav.mobile-view .vasion-active-list-item * {
  color: $primary;
}
::v-deep .vap-lyt-1-main-side-nav.mobile-view .vasion-ul-with-icons li:hover * {
  color: $primary;
}
.vap-lyt-1-main-side-nav ::v-deep button {
  margin-left: 0px;
  margin-right: 0px;
  width: 100%;
}
.vap-lyt-1-main-side-nav ::v-deep .vasion-side-nav-li-background {
  margin-left: 0px;
  margin-right: 0px;
  width: 100%;
}
.vap-lyt-1-main-side-nav ::v-deep .side-nav-content {
  padding-bottom: 16px;
}
.vap-lyt-1-main {
  flex: 1;
  min-width: calc(100vw - 360px);
}
// -------------------------------------------------------------- End of LAYOUT
// ------------------------------------------------------------- Start of DEBUG
.vap-lyt-1-side-rail.debug {
  background-color: goldenrod;
  color: transparent;
}
.vap-lyt-1-top-bar.debug {
  background-color: #ff0000;
  color: transparent;
}
.vap-lyt-1-main-side-nav.debug {
  background-color: #800080;
  color: transparent;
}
.vap-lyt-1-main-side-nav.debug {
  background-color: blanchedalmond;
  color: transparent;
}
.vap-lyt-1-main.debug {
  background-color: royalblue;
  color: transparent;
}
::v-deep .vap-lyt-1-side-rail.debug *,
::v-deep .vap-lyt-1-top-bar.debug *,
::v-deep .vap-lyt-1-main-side-nav.debug *,
::v-deep .vap-lyt-1-main-side-nav.debug *,
::v-deep .vap-lyt-1-main.debug * {
  visibility: hidden;
}
// --------------------------------------------------------------- End of DEBUG
// ---------------------------------------------------------- Start of SEARCHER
::v-deep .vasion-search-overlay {
  z-index: 1200 !important;
}
::v-deep .vasion-search .relative {
  z-index: 1220 !important;
}
::v-deep .vasion-search .relative .container {
  top: 44px;
}
// ------------------------------------------------------------ End of SEARCHER
// ----------------------------------------------------- Start of general fixes
::v-deep nav#pro-rail {
  z-index: 30 !important;
}
::v-deep #product-bridge > div > div {
  z-index: 10 !important;
}
::v-deep
  #product-bridge
  > div
  > nav.v-navigation-drawer.v-navigation-drawer--left.v-navigation-drawer--temporary.v-theme--VasionLightTheme.bg-surface-variant.elevation-0 {
  z-index: 20 !important;
}
::v-deep .tab-container {
  width: 100% !important;
}
::v-deep .defaultFillColor {
  @include breakpoint(md) {
    fill: $on-surface-variant !important;
    color: $on-surface-variant !important;
  }
}
::v-deep .side-nav-folders li .folderText {
  @include breakpoint(md) {
    fill: $on-surface-variant !important;
    color: $on-surface-variant !important;
  }
}
// ------------------------------------------------------- End of general fixes
</style>
